import SubHeader from "./SubHeader"

export default  SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/Profile/SubHeader/index.js